export const statusChecked = (percent: number): string | any => {
  if (percent === -1) {
    return "errors";
  } else if (percent === 0) {
    return "draft";
  } else if (percent > 0 && percent <= 10) {
    return "start";
  } else if (percent > 10 && percent <= 20) {
    return "one";
  } else if (percent > 20 && percent <= 25) {
    return "two";
  } else if (percent > 25 && percent <= 30) {
    return "three";
  } else if (percent > 30 && percent <= 35) {
    return "four";
  } else if (percent > 35 && percent <= 40) {
    return "five";
  } else if (percent > 40 && percent <= 50) {
    return "six";
  } else if (percent > 50 && percent < 60) {
    return "seven";
  } else if (percent >= 60 && percent < 70) {
    return "eight";
  } else if (percent >= 70 && percent < 80) {
    return "nine";
  } else if (percent >= 80 && percent < 90) {
    return "ten";
  } else if (percent >= 90 && percent < 100) {
    return "eleven";
  } else if (percent >= 100) {
    return "twelve";
  } else {
    return "default";
  }
};
